import { KEYCODE } from '../../../../constants';
import template from './popup-toggle-button.html';
import './popup-toggle-button.global.css';

const TOGGLE_KEY_CODES = [KEYCODE.RETURN, KEYCODE.SPACE];

class PopupToggleButtonController {
  constructor(updPopupToggleService) {
    'ngInject';
    Object.assign(this, { updPopupToggleService });
  }

  get popupRole() {
    // A popup's ARIA role is one of "menu", "listbox", "tree", "grid" or "dialog".
    // It should match the role of the popup. The spec defaults the role to "menu".
    // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
    return this._popupRole || 'menu';
  }

  set popupRole(value) {
    this._popupRole = value;
  }

  handleKeyPress(event) {
    if (TOGGLE_KEY_CODES.indexOf(event.keyCode) !== -1) {
      this.toggle();
    }
  }

  toggle() {
    this.updPopupToggleService.toggle(this.popupId);
  }
}

export const PopupToggleButtonComponent = {
  controller: PopupToggleButtonController,
  bindings: {
    buttonId: '@',
    popupId: '@',
    popupRole: '@',
  },
  transclude: true,
  template,
};
